var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"self",class:[ 'sub-tab-group', _vm.orientation ],style:({ width: _vm.orientation === 'vertical' ?  220 + 'px' : 'auto' }),attrs:{"data-dusk":"sub-tab-group"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }